import * as React from 'react';
import { Model, Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { AddressContainer } from '../../containers/AddressContainer';
import { IAddressDetails } from '../../types/companyDetails';
import { getShowDetails, setShowDetails } from '../../helpers/storage';
import { setPostalCodeValue } from '../../helpers/companyDetails';

export const TYPE = 'mui-address';

export class MuiAddressModel extends Question {
  getType(): string {
    return TYPE;
  }
}

export class MuiAddress extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.setAddressDetails = this.setAddressDetails.bind(this);
    this.showDetails = this.showDetails.bind(this);
    this.getCountry = this.getCountry.bind(this);
    const model = this.question.survey as Model;
    model.setVariable('showDetails', getShowDetails());
  }

  get question() {
    return this.questionBase;
  }

  handleChange(address: string) {
    this.question.value = address;
  }

  handleBlur({ target: { value } }: React.FocusEvent<HTMLInputElement>) {
    this.question.value = value ? value.trim() : value;
  }

  showDetails() {
    const model = this.question.survey as Model;
    model.setVariable('showDetails', true);
    setShowDetails();
  }

  setAddressDetails(details: IAddressDetails) {
    const model = this.question.survey as Model;
    const address1 = model.getQuestionByName('address1');
    const address2 = model.getQuestionByName('address2');
    const townOrCity = model.getQuestionByName('townOrCity');
    const postalCode = model.getQuestionByName('postalCode');
    address1.value = details.addressLine1 || '';
    address2.value = details.addressLine2 || '';
    townOrCity.value = details.city || '';
    setPostalCodeValue(postalCode, details.postalCode);
    this.showDetails();
  }

  getCountry() {
    const model = this.question.survey as Model;
    return model.getQuestionByName('country').value;
  }

  protected renderElement(): JSX.Element | null {
    const { value = '', title, name, isRequired, errors, readOnly } = this.question;

    return (
      <AddressContainer
        value={value}
        title={title}
        name={name}
        getCountry={this.getCountry}
        isRequired={isRequired}
        disabled={readOnly}
        errors={errors}
        setAddressDetails={this.setAddressDetails}
        showDetails={this.showDetails}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
      />
    );
  }
}
